import React from "react";
import styled from "styled-components";
import FlexRow from "../components/FlexRow";
import Card from "../components/Card";
import ShadowImage from "../components/ShadowImage";
import adam from "../images/adam.jpg";
import casey from "../images/casey.jpg";

const ImageContainer = styled.div`
  display: inline-block;

  flex: 1 0 40%;

  margin: 0.5rem;
`;

const OurStoryPage = () => (
  <div>
    <Card header="Adam Fishman & Casey Lee">
      <FlexRow>
        <ImageContainer>
          <ShadowImage src={adam} />
        </ImageContainer>
        <ImageContainer>
          <ShadowImage src={casey} />
        </ImageContainer>
      </FlexRow>
      <p>
        It was January 2017. Casey had just moved to Denver and was getting
        settled in at his new job and home. Adam was also getting settled into
        his new home after moving back to Denver from Colorado Springs. Casey
        had logged back into Plenty of Fish for the first time in quite a while
        just to see if he could meet some new people in the area since he didn't
        know anyone living in Denver at the time. Little did he know, he would
        soon meet Adam which would vault their life into something different and
        unexpected.
      </p>
      <p>
        During Casey's second week of employment in Denver, we started talking
        on Plenty of Fish and then we first met in person on the evening of
        February 4th after Casey had spent the day downtown at a Star Wars
        exhibit at the Denver Art Museum. We sat and talked over dinner for over
        four hours and then talked for a few more hours afterwards. After that
        night, we spent time together daily and it was all over from there.
      </p>
      <p>
        We enjoyed a busy summer full of concerts, plays, and comedy shows
        allowing us to get to know each other more every day. By the time July
        rolled around, we decided that we wanted to live together. As a result,
        Casey moved into Adam's place along with him and his kitty Murphy.
      </p>
      <p>
        After a great holiday season together, it was New Year's Eve. We had a
        nice dinner that evening and afterwards, we went home to feed Murphy
        before heading downtown for fireworks. That was when Adam{" "}
        <a href="http://wedding.adamsuniverse.com/proposal" target="_blank">
          proposed via a website
        </a>{" "}
        that he had created based on our time together. Casey, of course, said
        YES!
      </p>
      <p>
        A year to the day since first meeting, this website was released to our
        family and friends to announce the wedding of Adam and Casey on
        Saturday, August 18, 2018. We look forward to celebrating this special
        day with those closest to us.
      </p>
    </Card>
  </div>
);

export default OurStoryPage;



// WEBPACK FOOTER //
// ./src/pages/our-story.js